function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiwDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.40308,0,0,1.40803,-16.1231,-16.3016)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.15625,0,0,0.15625,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.544,205.156L316.484,179.956C318.891,173.118 320.12,165.92 320.12,158.671C320.12,123.496 291.175,94.551 256,94.551C220.825,94.551 191.88,123.496 191.88,158.671C191.88,165.92 193.109,173.118 195.516,179.956L130.456,205.156C127.774,206.202 125.999,208.801 126,211.68L126,362.592C125.999,365.475 127.78,368.077 130.468,369.12L253.468,416.8C254.276,417.112 255.134,417.272 256,417.272C256.857,417.254 257.703,417.078 258.496,416.752L258.532,416.8L381.544,369.12C384.227,368.073 386.003,365.472 386,362.592L386,211.68C386.001,208.801 384.226,206.202 381.544,205.156ZM359.644,211.68L336.936,220.48L299.304,206C303.591,202.055 307.324,197.548 310.4,192.6L359.644,211.68ZM285.536,215.704L317.536,228.012L299.468,235.012L266.324,222.064C273.026,220.982 279.512,218.834 285.536,215.704ZM307.316,246.98L330.824,237.868L330.824,267.032L326.892,264.468C324.065,262.628 320.291,263.078 317.976,265.532L307.316,276.844L307.316,246.98ZM256,108.728C283.495,108.728 306.12,131.353 306.12,158.848C306.12,186.343 283.495,208.968 256,208.968C228.505,208.968 205.88,186.343 205.88,158.848C205.911,131.365 228.517,108.759 256,108.728ZM205.6,198.328L196.232,194.668L201.596,192.588C202.825,194.577 204.162,196.497 205.6,198.34L205.6,198.328ZM176.924,202.152L280.14,242.5L256,251.856L152.356,211.68L176.924,202.152ZM140,357.796L140,221.904L249,264.16L249,400.052L140,357.796ZM263,400.052L263,264.16L293.316,252.4L293.316,294.484C293.317,297.347 295.075,299.933 297.736,300.988C298.556,301.316 299.432,301.485 300.316,301.484C302.244,301.485 304.09,300.688 305.412,299.284L324.152,279.392L334.004,285.792C335.136,286.524 336.456,286.913 337.804,286.913C341.639,286.913 344.796,283.762 344.804,279.928L344.804,232.44L372,221.904L372,357.796L263,400.052Z",
    style: {
      fill: "rgb(10,45,113)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.15625,0,0,0.15625,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.532,179.448C246.19,181.697 250.142,181.639 252.732,179.312L286.68,148.8C288.263,147.471 289.178,145.506 289.178,143.439C289.178,139.599 286.018,136.439 282.178,136.439C280.367,136.439 278.624,137.143 277.32,138.4L247.912,164.836L234.52,153.516C233.257,152.448 231.654,151.861 230,151.861C226.16,151.861 222.999,155.022 222.999,158.862C222.999,160.921 223.908,162.879 225.48,164.208L243.532,179.448Z",
    style: {
      fill: "rgb(10,45,113)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiwDelivered);
export default __webpack_public_path__ + "static/media/HIW-delivered.f2a9d3b3ea7ee93c5b69a69725591ae2.svg";
export { ForwardRef as ReactComponent };